import Parse from 'parse';
import defaultTo from 'lodash/defaultTo';

export const getValueOrDefault =
  (getDefault: (name: string) => any) => (obj: Parse.Object | any, name: string) =>
    defaultTo(obj instanceof Parse.Object ? obj.get(name) : obj[name], getDefault(name));
